import type { FC, ReactElement } from "react";

import { PixelPlaceholderLoader } from "@similarweb/ui-components";

import { StyledListItemLoaderWrapper, StyledListItemLoader, StyledListItemDescriptionLoader } from "./styles";

type ListPreLoaderItemProps = {
    rowNumber: number;
};
const ListPreLoaderItem: FC<ListPreLoaderItemProps> = ({ rowNumber = 3 }): ReactElement[] => {
    const loaderItems = [];

    for (let index = 1; index <= rowNumber; index++) {
        loaderItems.push(
            <StyledListItemLoaderWrapper key={`loader_${index}`}>
                <StyledListItemLoader>
                    <PixelPlaceholderLoader
                        width={24}
                        height={24}
                    />
                    <StyledListItemDescriptionLoader>
                        <PixelPlaceholderLoader
                            width={244}
                            height={22}
                        />
                        <PixelPlaceholderLoader
                            width={180}
                            height={14}
                        />
                    </StyledListItemDescriptionLoader>
                </StyledListItemLoader>
            </StyledListItemLoaderWrapper>,
        );
    }

    return loaderItems;
};

export default ListPreLoaderItem;
